import { BehaviourAdapter } from '../predictive-searcher/behaviour-adapter';
import {  NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { PredictiveSearcherComponent } from '../predictive-searcher/predictive-searcher.component';

@Component({
    selector: 'app-city-selector',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        PredictiveSearcherComponent
    ],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => CitySelectorComponent),
      },
    ],
    template: `
      <predictive-searcher
        label="Municipio"
        [formControl]="form"
        [service]="adapter">
      </predictive-searcher>`,
    styleUrls: ['./city-selector.component.css']
})

export class CitySelectorComponent extends BehaviourAdapter implements OnInit {

  constructor(
    private apiManager: ApiManagerService,
  ) {
    super();

    this.adapter = (data) => {
      return this.apiManager.getFromCatalog('city', { text: data.text});
    };
  }

  ngOnInit(): void {
    this.subscribe();
  }

}
